module.exports = __webpack_public_path__ + "static/media/w-2_14.feca89ac.png";